import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Import shared translations
import sharedProfilePl from '@shared/locales/pl/profile.json';
import sharedProfileEn from '@shared/locales/en/profile.json';
import sharedReservationPl from '@shared/locales/pl/reservation.json';
import sharedReservationEn from '@shared/locales/en/reservation.json';
// Import local translations
import translationPl from './locales/pl/translation.json';
import translationEn from './locales/en/translation.json';

// Deep merge function for translations
const deepMerge = (target: any, source: any): any => {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key] = deepMerge(result[key] || {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pl: {
        translation: deepMerge(deepMerge(sharedProfilePl, sharedReservationPl), translationPl)
      },
      en: {
        translation: deepMerge(deepMerge(sharedProfileEn, sharedReservationEn), translationEn)
      }
    },
    lng: 'pl',
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
